import { ICopyable } from '../controls/common/icopyable';
import { IOrganization } from './interfaces/organization.interface';

export class Organization implements IOrganization, ICopyable<Organization> {
    public id: string = null;
    public name: string = null;
    public billingCode: string = null;
    public creationDate: Date = null;
    public updateDate: Date = null;
    public isAllowedToAccessHub4B: boolean = null;
    public organizationId: string = null;
    public archivingEnabled: boolean = false;
    public officeDomain: string = null;

    public createCopy(): Organization {
        const instance = new Organization();
        instance.id = this.id;
        instance.name = this.name;
        instance.billingCode = this.billingCode;
        instance.creationDate = this.creationDate;
        instance.updateDate = this.updateDate;
        instance.isAllowedToAccessHub4B = this.isAllowedToAccessHub4B;
        instance.organizationId = this.organizationId;
        instance.archivingEnabled = this.archivingEnabled;
        instance.officeDomain = this.officeDomain;
        return instance;
    }

    public static createFormCopy(organization: Organization): IOrganization {
        const instance = new Organization();
        instance.id = organization.id;
        instance.name = organization.name;
        instance.billingCode = organization.billingCode;
        instance.creationDate = organization.creationDate;
        instance.updateDate = organization.updateDate;
        instance.isAllowedToAccessHub4B = organization.isAllowedToAccessHub4B;
        instance.organizationId = organization.organizationId;
        instance.archivingEnabled = organization.archivingEnabled;
        instance.officeDomain = organization.officeDomain;
        return instance;
    }

    public static Map(other: IOrganization): Organization {
        const instance = new Organization();
        instance.id = other.id;
        instance.name = other.name;
        instance.billingCode = other.billingCode;
        instance.creationDate = other.creationDate;
        instance.updateDate = other.updateDate;
        instance.isAllowedToAccessHub4B = other.isAllowedToAccessHub4B;
        instance.organizationId = other.organizationId;
        instance.archivingEnabled = other.archivingEnabled;
        instance.officeDomain = other.officeDomain;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.billingCode = other.billingCode;
        this.creationDate = other.creationDate;
        this.updateDate = other.updateDate;
        this.isAllowedToAccessHub4B = other.isAllowedToAccessHub4B;
        this.organizationId = other.organizationId;
        this.archivingEnabled = other.archivingEnabled;
        this.officeDomain = other.officeDomain;
    }

    /**
     * Retourne une instance de Organisation à partir d'une instance de IOrganization.
     * @param other : Instance de IOrganisation.
     * @returns : Instance de Organisation.
     */
    public static from(other: IOrganization) {
        if (!!other) {
            const instance = new Organization();

            instance.id = other.id;
            instance.name = other.name;
            instance.billingCode = other.billingCode;
            instance.creationDate = other.creationDate;
            instance.updateDate = other.updateDate;
            instance.isAllowedToAccessHub4B = other.isAllowedToAccessHub4B;
            instance.organizationId = other.organizationId;
            instance.archivingEnabled = other.archivingEnabled;
            instance.officeDomain = other.officeDomain;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de Organisation à partir d'un tableau d'instances de IOrganization.
     * @param other : Tableau d'instances de IOrganization.
     * @returns : Tableau d'instances de Organisation.
     */
    public static fromArray(others: IOrganization[]) {
        if (!!others) {
            let organizations: Organization[] = [];

            others.forEach((x) => {
                const organization = Organization.from(x);
                organizations.push(organization);
            });

            return organizations;
        } else {
            return null;
        }
    }

    public getDisplayName() {
        return `${this.name}`;
    }
}
